import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=e1264efc"
import script from "./CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "./CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./create-dialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports